<vs-dialog [config]="{ dialogContainerClass: 'max-w-[560px]' }">
  <vs-dialog-header
    [config]="{
      mode: 'simple',
      showDivider: true,
      icon: 'hourglass-01',
      iconTheme: 'primary',
      title: config.holdDialog.title,
      subtitle: config.holdDialog.subtitle
    }"
  ></vs-dialog-header>

  <form class="flex flex-col gap-4 p-4" [formGroup]="form">
    <div class="grid grid-cols-2 gap-4">
      <vs-form-field [config]="{ label: config.holdDialog.type }">
        <vs-select vsInput formControlName="type">
          <li *ngFor="let type of types" vs-select-option [value]="type">{{ config.holds.types[type] }}</li>
        </vs-select>
      </vs-form-field>

      <vs-form-field [config]="{ label: config.holdDialog.dueDate }">
        <vs-input-container>
          <input formControlName="dueDate" class="picker-indicator-hidden" type="date" data-testid="hold-due-date" />
          <button
            vs-icon-button
            type="button"
            size="xs"
            appearance="clear"
            slot="end"
            [vsMenuTriggerFor]="dueDateMenu"
            #dueDateTrigger="vsMenuTriggerFor"
          >
            <vs-icon [vsTooltip]="config.holdDialog.openDatePicker" name="calendar" size="16"></vs-icon>
          </button>
        </vs-input-container>
        <ng-template #dueDateMenu>
          <vs-menu>
            <vs-date-picker
              vs-menu-item
              [value]="pickerDate()"
              [range]="false"
              (selectionChanged)="pickDueDate($any($event), dueDateTrigger)"
            ></vs-date-picker>
          </vs-menu>
        </ng-template>
      </vs-form-field>
    </div>

    <vs-form-field [config]="{ label: config.holdDialog.charge }">
      <vs-select
        vsInput
        formControlName="claimItemLineId"
        [config]="{ placeholder: config.holdDialog.chargePlaceholder }"
      >
        <li vs-select-option [value]="null">{{ config.holds.wholeJob }}</li>
        <li *ngFor="let line of activeLines" vs-select-option [value]="line.id">{{ line.description }}</li>
      </vs-select>
    </vs-form-field>

    <vs-form-field [config]="{ label: config.holdDialog.evidence }">
      <textarea
        vsInput
        formControlName="requestedEvidence"
        [placeholder]="config.holdDialog.evidencePlaceholder"
      ></textarea>
    </vs-form-field>

    <vs-form-field [config]="{ label: config.holdDialog.owner }">
      <vs-select vsInput formControlName="owner" [config]="{ placeholder: config.holdDialog.ownerPlaceholder }">
        <li *ngFor="let owner of owners" vs-select-option [value]="ownerKey(owner)">
          {{ owner.name }} · {{ config.holds.ownerTypes[owner.ownerType] }}
        </li>
      </vs-select>
    </vs-form-field>
  </form>

  <div class="flex justify-end gap-2 px-4 pb-4">
    <button vs-button appearance="outline" (click)="close()">{{ config.holdDialog.cancel }}</button>
    <button vs-button theme="primary" [disabled]="form.invalid || saving" (click)="save()">
      {{ config.holdDialog.save }}
    </button>
  </div>
</vs-dialog>
